export const enum CheckRegexpEqualityEnum {
  all = 'all',
  any = 'any'
}
